// @ vendors
const React = require('react');
// @ components
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');
// @ utils
const { formatText } = require('core/i18n').i18n;

class UnknownSecurityLevelView extends React.Component {
    render() {
        const params = {
            title: formatText('unknownSecurityLevel-title'),
            subtitle: formatText('unknownSecurityLevel-subtitle'),
            icon: 'icon-warning',
        };
        return (
            <div className="unknown-security-level-view">
                <CustomMessageBox {...params} />
            </div>
        );
    }
}

module.exports.UnknownSecurityLevelView = UnknownSecurityLevelView;
